/* unplugin-vue-components disabled */import { render } from "./BudgetReport.vue?vue&type=template&id=3fd720e8&scoped=true&ts=true"
import script from "./BudgetReport.vue?vue&type=script&lang=ts"
export * from "./BudgetReport.vue?vue&type=script&lang=ts"

import "./BudgetReport.vue?vue&type=style&index=0&id=3fd720e8&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fd720e8"]])

export default __exports__